import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import SettingsIcon from '@material-ui/icons/Settings';
import { Profile, SidebarNav } from './components';
import { useTranslation } from 'react-i18next'
import { useAuth } from "use-auth.js";
import firebase from "firebase/app";

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = props => {
  const { open, variant, onClose, className, ...rest } = props;

  const { t } = useTranslation()
  const classes = useStyles();
  const { user } = useAuth()
  let { uid: userId } = user || {}
  const [userData, setUserData] = useState([])
  

  let menuUser = [
    {
      title:  t('Company & Events'),
      href: '/companies',
      icon: <ShoppingBasketIcon />
    },
    {
      title: t('My AGM Events'),
      href: '/eventlist',
      icon: <SettingsIcon />
    },
    {
      title: t('Proxy'),
      href: '/dashboard',
      icon: <DashboardIcon />
    },
    {
      title: t('Personal Setting'),
      href: '/account',
      icon: <AccountBoxIcon />
    }
  ];

  let menuAdmin = [
    {
      title: t('Verify Users'),
      href: '/verifyusers',
      icon: <SettingsIcon />
    },
    {
      title: t('View Votings'),
      href: '/viewvotings',
      icon: <SettingsIcon />
    },
    {
      title:  t('View Events'),
      href: '/eventview',
      icon: <ShoppingBasketIcon />
    }
  ];

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function(myuser) {
      if (myuser) {
        userId = myuser.uid
        
        const unsubscribe = firebase
          .firestore()
          .collection('agmusers')
          .doc(userId).onSnapshot(doc => {
          setUserData(doc.data()) 
        })
        return () => { unsubscribe() }
      }
    })
  }, [userId])

  
  const getMenuSideBar = () =>{

    if(userData?.type === "admin") return menuAdmin
    return menuUser
  }
  
  

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Profile 
          userData={userData}
        />
        <Divider className={classes.divider} />
        <SidebarNav
          className={classes.nav}
          pages={getMenuSideBar()}
        />
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
